import SignUpStepContainer from "./SignUpStepContainer";
import { FC, useEffect, useRef } from "react";
import { createWidget } from "@typeform/embed";
import { REGISTRATION_STEPS } from "@/data";

const QuestionnaireStep: FC<{
  onSubmit?: () => void;
  productSteps: REGISTRATION_STEPS[] | undefined;
}> = ({ onSubmit, productSteps }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      createWidget(import.meta.env.VITE_TYPEFORM_SIGNUP_ID, {
        container: containerRef.current,
        onSubmit,
        hideHeaders: true,
        hideFooter: true,
        opacity: 0,
      });

      const interval = setInterval(() => {
        const tfWidget = containerRef.current?.querySelector(
          '[data-testid="tf-v1-widget"]'
        ) as HTMLElement;
        const iframe = containerRef.current?.querySelector(
          "iframe"
        ) as HTMLElement;

        if (tfWidget && iframe) {
          tfWidget.style.height = "100%";
          tfWidget.style.width = "100%";
          iframe.style.height = "100%";
          iframe.style.width = "100%";
          clearInterval(interval);
        }
      }, 50);
    }
  }, []);

  return (
    <SignUpStepContainer
      productSteps={productSteps}
      step={REGISTRATION_STEPS.QUESTIONAIRE}
      header="Jūsų atsakymai – mūsų pasiruošimas"
      description={[
        "Norėdami geriau Jus pažinti, prašome užpildyti trumpą klausimyną.",
        "Jis padės mūsų specialistams pasiruošti konsultacijai ir pasiūlyti tik Jums pritaikytą sprendimą.",
        "Atsakymai yra konfidencialūs ir užtruksite vos kelias minutes.",
      ]}
    >
      <div
        ref={containerRef}
        style={{
          width: "100%",
          height: "800px",
          marginBottom: "60px",
        }}
      />
    </SignUpStepContainer>
  );
};

export default QuestionnaireStep;
